<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
<path d="M15.6113 18.5L9.21499 12.7433C8.77361 12.3461 8.77361 11.6539 9.21499 11.2567L15.6113 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>
